var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBusy1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C50202"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4514 18.7276C23.9131 24.0319 18.3414 27.1731 13.0068 25.7437C10.445 25.0572 8.28155 23.387 6.99245 21.1005C5.70334 18.814 5.39415 16.0984 6.13288 13.5512C7.6712 8.24693 13.2428 5.10573 18.5775 6.53515C23.9122 7.96457 26.9897 13.4233 25.4514 18.7276ZM13.2095 10.7586L12.55 11.1304C12.4282 11.1972 12.338 11.3092 12.2997 11.4412C12.2615 11.5732 12.2784 11.7139 12.3466 11.8315L14.8418 16.2574L13.4102 21.194C13.3332 21.4592 13.4871 21.7321 13.7539 21.8036L14.488 22.0003C14.7547 22.0718 15.0333 21.9147 15.1102 21.6495L16.6895 16.2039C16.7292 16.0742 16.713 15.9349 16.6449 15.8193L13.8953 10.9423C13.7577 10.7069 13.454 10.6256 13.2095 10.7586Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBusy1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Busy-1.46f259ba.svg";
export { ForwardRef as ReactComponent };